
import { formatPrice } from '../../../utils/utils'
export default {
  name: 'FilterPrice',
  // eslint-disable-next-line vue/require-prop-types
  props: ['dataFilter', 'buttonLoadMore', 'isProduct', 'limit', 'textValue', 'textName', 'keyFilter', 'updateState', 'updateRangeState'],
  data() {
    return {
      listData: [],
      listValue: {
        value: [],
        minValue: null,
        maxValue: null,
        errors: {}
      },
      minPrice: '',
      maxPrice: '',
      listRules: {
        minValue: [
        ],
        maxValue: [
        ]
      },
      showListFilter: true,
      loadMore: false,
      itemValue: 'id',
      itemName: 'value'
    }
  },
  computed: {
    errorMessage() {
      let error = ''
      if (this.listValue.maxValue && this.listValue.minValue) {
        error = (Number(this.listValue.maxValue) < Number(this.listValue.minValue)) ? this.$t('filter.validate_min_max') : ''
      }
      return error
    }
  },
  watch: {
    minPrice(val) {
      if (isNaN(val.replaceAll('.', '')) || parseFloat(val.replaceAll('.', '')) === 0) {
        this.minPrice = ''
      } else if (val) {
        if (this.listValue.minValue !== val.replaceAll('.', '')) {
          this.listValue.minValue = val.replaceAll('.', '')
        }
      }
    },
    'listValue.minValue'(val) {
      this.minPrice = formatPrice((Number(val)))
    },
    maxPrice(val) {
      if (isNaN(val.replaceAll('.', '')) || parseFloat(val.replaceAll('.', '')) === 0) {
        this.minPrice = ''
      } else if (val) {
        if (this.listValue.maxValue !== val.replaceAll('.', '')) {
          this.listValue.maxValue = val.replaceAll('.', '')
        }
      }
    },
    'listValue.maxValue'(val) {
      this.maxPrice = formatPrice((Number(val)))
    },
    'listValue.value'() {
      this.changeListValue()
    },
    'updateState.status'() {
      const data = []
      this.dataFilter.list.forEach(filter => {
        if (this.updateState.list.includes(String(filter.id)) || this.updateState.list.includes(filter.id)) {
          data.push(filter.id)
        }
      })
      this.listValue.value = data
    },
    'updateRangeState.status'() {
      let check = false
      if (this.updateRangeState.list[0] !== undefined) {
        check = true
        this.listValue.minValue = Number(this.updateRangeState.list[0])
      }
      if (this.updateRangeState.list[1] !== undefined) {
        check = true
        this.listValue.maxValue = Number(this.updateRangeState.list[1])
      }
      if (check) {
        this.applyRange(this.listValue.minValue, this.listValue.maxValue, formatPrice(this.updateRangeState.list[0] || ''),
          formatPrice(this.updateRangeState.list[1] || ''))
      }
    }
  },
  created() {
    if (this.textValue) {
      this.itemValue = this.textValue
    }
    if (this.textName) {
      this.itemName = this.textName
    }
  },
  methods: {
    resetValidate(ref) {
      this.$refs.listValue.fields.find((f) => f.prop === ref).clearValidate()
      this.listValue.errors[ref] = ''
    },
    checkShow(index) {
      if (this.buttonLoadMore !== true) return true
      if ((this.loadMore === false) && (index >= this.limit)) return false
      return true
    },
    changeListValue() {
      const list = []
      const listValue = []
      this.dataFilter.list.forEach(data => {
        if (this.listValue.value.includes(data.id)) {
          list.push(data.value)
          listValue.push(data.id)
        }
      })
      this.$emit('change', {
        type: this.keyFilter,
        value: list,
        list: listValue,
        title: this.$t('filter.price')
      })
    },
    applyPriceRange() {
      if ((this.errorMessage === '') && (this.minPrice || this.maxPrice)) {
        this.applyRange(this.listValue.minValue, this.listValue.maxValue, this.minPrice, this.maxPrice)
      }
    },
    applyRange(min, max, minValue, maxValue) {
      let value = this.$t('filter.text_between_price', { min: minValue, max: maxValue })
      let list = `${min},${max}`
      if (minValue === '') {
        value = this.$t('filter.less_price', { max: maxValue })
        list = `0,${max}`
      }
      if (maxValue === '') {
        value = this.$t('filter.than_price', { min: minValue })
        list = `${min}`
      }
      this.$emit('change', {
        type: 'price_range',
        value: [value],
        list: [list],
        title: this.$t('filter.price')
      })
    }
  }
}
